import { cloneDeep } from '@apollo/client/utilities';

import { getProductPricingQueryParameters } from './getProductGridQueryParameters';
import { BASE_PRODUCTS_PRICING_QUERY } from './queries';

export default async function getGqlProductPricing({
  apolloClient,
  setProductPricingMap = null,
  products,
}) {
  if (!products?.length) {
    return;
  }

  const productPricingVariables = getProductPricingQueryParameters({
    productListing: products,
  });

  const {
    data: { productListing: productPricingListing },
  } = await apolloClient.query({
    context: { clientName: 'supergraph' },
    query: BASE_PRODUCTS_PRICING_QUERY,
    variables: productPricingVariables,
  });

  const pricingResults = cloneDeep(
    productPricingListing?.products?.reduce(
      (acc, product) => ({
        ...acc,
        [product.masterProductId]: {
          pricing: product.pricing,
          retailUnitPrice: product.pricing.retail,
          defaultUnitPrice: product.pricing.final,
          promos: product.pricing.finalDetails,
          promoCode: product.pricing.finalDetails?.promoCode,
        },
      }),
      {}
    )
  );

  const productsWithPricing = products.map(product => {
    const pricing = pricingResults[product.masterProductId];

    if (pricing) {
      return {
        ...product,
        ...pricing,
      };
    }

    return product;
  });

  if (setProductPricingMap) {
    setProductPricingMap(productPricingMap => {
      return {
        ...productPricingMap,
        ...pricingResults,
      };
    });
  }

  return {
    pricingMap: pricingResults,
    productsWithPricing: productsWithPricing,
  };
}
